import styled from 'styled-components';

export const BaseColWrap = styled.td`
  width: 23%;
  padding: 20px 20px 20px 0; 
`;

export const SmallGreySpan = styled.span`
    color: #94949b;
    font-size: 1.4rem
`;

export const ContactInfoContainer = styled.td`
  display: flex;
  padding-top:20px;
  padding-bottom:20px;
`;

export const ContactInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
`;

export const ImageContainer = styled.div`
    padding-right: 15px;
    width: 30%;
    
    img {
      width: 50%;
      border-radius: 50%;
    }
`;

export const AgentName = styled.span`
 color: #6A2200;
 font-weight: 800;
 font-size: 1.6rem;
 margin-bottom: 10px;
 
`;

export const AgencyName = styled.span`
  font-weight: 800;
  font-size: 1.4rem;
  color: #55555F;
`;
export const Location = styled(SmallGreySpan)`

`;

export const ContactPhoneEmail = styled(SmallGreySpan)``;

export const WebsiteLink = styled.a`
  color: #6A2200;
  font-size: 1.2rem;
  text-decoration: underline;
`;

export const Distance = styled(BaseColWrap)`
  width: inherit;
`;
export const Languages = styled(BaseColWrap)`
 width: inherit;
`;
export const Products = styled(BaseColWrap)``;